import React, { useState, useEffect } from 'react';
import dbService from '../../../services/dbService';
import { toast } from 'react-toastify';
import { Trash, PlusCircle } from 'react-bootstrap-icons';
import { Button, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { useAuth } from '../../../context/AuthContext';
import { usePermissions } from '../../../hooks/usePermissions';
import PageContainer from '../../layout/PageContainer';

const MasterListEditor = ({ listId, title }) => {
    const [masterData, setMasterData] = useState({ id: listId, data: [] });
    const [newItem, setNewItem] = useState('');
    const { user } = useAuth();
    const { permissions } = usePermissions();

    const fetchData = async () => {
        const data = await dbService.getById('masters', listId);
        if (data) setMasterData(data);
    };

    useEffect(() => { fetchData(); }, [listId]);

    const handleAddItem = async () => {
        if (newItem.trim() && !masterData.data.includes(newItem.trim())) {
            const updatedData = { ...masterData, data: [...masterData.data, newItem.trim()] };
            await dbService.update('masters', updatedData);
            await dbService.addLog({user: user.name, action: 'Master Data Updated', details: `Added '${newItem}' to ${title}`});
            toast.success(`'${newItem}' added to ${title}.`);
            setNewItem('');
            fetchData();
        } else {
            toast.error('Item is empty or already exists.');
        }
    };
    
    const handleRemoveItem = async (itemToRemove) => {
        const updatedData = { ...masterData, data: masterData.data.filter(i => i !== itemToRemove) };
        await dbService.update('masters', updatedData);
        await dbService.addLog({user: user.name, action: 'Master Data Updated', details: `Removed '${itemToRemove}' from ${title}`});
        toast.warn(`'${itemToRemove}' removed from ${title}.`);
        fetchData();
    };

    return (
        <div className="card mb-4">
            <div className="card-header">{title}</div>
            <div className="card-body">
                <div className="input-group mb-3">
                    <input type="text" className="form-control" placeholder="Add new item..." value={newItem} onChange={e => setNewItem(e.target.value)} disabled={!permissions.canManageMasters}/>
                    {permissions.canManageMasters ? (
                        <Button variant="primary" onClick={handleAddItem}><PlusCircle /></Button>
                    ) : (
                        <OverlayTrigger overlay={<Tooltip>Permission Denied</Tooltip>}><span className="d-inline-block"><Button variant="primary" disabled style={{ pointerEvents: 'none' }}><PlusCircle /></Button></span></OverlayTrigger>
                    )}
                </div>
                <ul className="list-group">
                    {masterData.data.map(item => (
                    <li key={item} className="list-group-item d-flex justify-content-between align-items-center">
                        {item}
                        {permissions.canManageMasters ? (
                            <Button variant="outline-danger" size="sm" onClick={() => handleRemoveItem(item)}><Trash /></Button>
                        ) : null}
                    </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

const Masters = () => {
  return (
    <PageContainer title='Masters Data Management'>
      <p>Manage core lists and parameters used across the system. (Admin only)</p>
      <MasterListEditor listId="highRiskCountries" title="High-Risk Countries" />
      <MasterListEditor listId="transactionTypes" title="Monitored Transaction Types" />
    </PageContainer>
  );
};

export default Masters;